import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const STORAGE_KEY = "saha-lab-cookie-consent";

const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const choice = localStorage.getItem(STORAGE_KEY);
      if (!choice) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      /* localStorage blocked — just hide for the session */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie notice"
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:end-6 sm:max-w-md z-[60] bg-[var(--text-primary)] text-[var(--bg-base)] rounded-2xl shadow-2xl border border-white/10 p-5 sm:p-6"
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-9 h-9 rounded-full bg-[var(--brand-gold)]/20 inline-flex items-center justify-center">
          <Cookie className="w-4 h-4 text-[var(--brand-gold)]" strokeWidth={1.75} />
        </div>
        <div className="flex-1">
          <p className="text-sm leading-relaxed text-[var(--bg-base)]/90">
            {t.cookies.message}
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-2">
            <button
              type="button"
              data-testid="cookie-accept-btn"
              onClick={() => dismiss("accepted")}
              className="px-4 h-10 rounded-full bg-[var(--brand-gold)] text-[var(--text-primary)] text-xs font-medium hover:bg-[var(--brand-gold-light)]"
            >
              {t.cookies.accept}
            </button>
            <button
              type="button"
              data-testid="cookie-decline-btn"
              onClick={() => dismiss("declined")}
              className="px-4 h-10 rounded-full border border-white/20 text-[var(--bg-base)] text-xs font-medium hover:bg-white/5"
            >
              {t.cookies.decline}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
